import { Route } from '@angular/router';

import { cricketTacticsSpectateOnlineGameRoutes } from '../online-games/games/cricket-tactics/online-games-cricket-tactics.routes';
import { matchSpectateGameRoutes } from '../online-games/games/match/online-games-match.routes';

export const spectatingOnlineGameRoutes: Route[] = [
    {
        path: 'online-game/killer/spectate/:id',
        data: { hideTournamentNotification: true, isSpectating: true },
        loadComponent: () =>
            import('../online-games/games/killer/pages/killer-online-gameplay/killer-online-gameplay.component').then(
                (c) => c.KillerOnlineGameplayComponent
            ),
    },
    ...matchSpectateGameRoutes,
    ...cricketTacticsSpectateOnlineGameRoutes,
];
